import configuration from '@zageno/config';
import logger from '@zageno/datadog';
import { initialize, LDClient, LDContext } from 'launchdarkly-js-client-sdk';
import { RefObject } from 'react';

export const anonymousContext = {
  anonymous: true,
  kind: 'user',
} as LDContext;

export function initLDClient(cb: () => void, client?: RefObject<LDClient>): LDClient {
  const ldClient =
    client?.current ||
    initialize(configuration.launchDarklyClientId, anonymousContext, {
      bootstrap: 'localStorage',
      sendEventsOnlyForVariation: false,
    });

  function handleFailure(error: Error) {
    logger.error('LDClient Initialization Failure', error);
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    cleanup();
  }

  function handleReady() {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    cleanup();
    cb();
  }

  ldClient.on('ready', handleReady);
  ldClient.on('failed', handleFailure);

  function cleanup() {
    ldClient.off('ready', handleReady);
    ldClient.off('failed', handleFailure);
  }

  return ldClient;
}
